import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faqhome',
  templateUrl: './faqhome.component.html',
  styleUrls: ['./faqhome.component.css']
})
export class FaqhomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
